import axios from './axiosService';
import { environment } from "../environment/environment";

const token = localStorage.getItem("token");

const httpOptions = {
  headers: {
    'Content-Type': 'application/json;charset=utf-8',
    'Authorization': `${token}`,
  },
};


const httpOptionsForgotpassword = {
  headers: {
    'Content-Type': 'application/json;charset=utf-8',
  },
};

const httpOptions3 = {
  headers: {
    'Content-Type': 'application/json;charset=utf-8',
    'Authorization': `${token}`,
  },
};


const API_ROOT_URL = environment.API_ROOT;
const FAQ_ROOT_URL = environment.FAQ_ROOT;
const RECORD_ROOT_URL = environment.RECORD_ROOT;
const MESSAGE_ROOT_URL = environment.MESSAGE_ROOT;
const CATEUPLOAD_ROOT_URL = environment.CATEUPLOAD_ROOT;
const ASSETSUPLOAD_ROOT_URL = environment.ASSETSUPLOAD_ROOT;
const EMAILUPLOAD_ROOT_URL = environment.EMAILUPLOAD_ROOT;
const USERUPLOAD_ROOT_URL = environment.USERUPLOAD_ROOT;
const LOCATION_ROOT_URL = environment.LOCATION_ROOT;
const DATA_ROOT_URL = environment.DATA_ROOT;
const REPORT_ROOT_URL = environment.REPORT_ROOT;
const MONITOR_ROOT_URL = environment.MONITOR_ROOT;
const KMMODULE_ROOT_URL = environment.KMMODULE_ROOT;
const QUEUE_ROOT_URL = environment.QUEUE_ROOT;


// Function to post data to the API
export const loginPostData = async (data) => {
  try {
    const response = await axios.post(`${API_ROOT_URL}/login`, data);
    const details = response.data.details;

    if (!Array.isArray(details) || details.length === 0) {
      console.warn("Login response 'details' is missing or empty.");
      return response.data; // Return whatever the API returned (likely unsuccessful)
    }

    const userDetails = details[0];
    localStorage.setItem('UserId', userDetails.userid);
    localStorage.setItem('clientId', userDetails.clientid);
    localStorage.setItem('organizationid', userDetails.mstorgnhirarchyid);
    localStorage.setItem('role', userDetails.role);
    localStorage.setItem('token', userDetails.token); // Store token

    return response.data;
  } catch (error) {
    console.error('Error posting data:', error);
    throw error;
  }
};




// Function to module  data from the API
export const fetchModuleByUserData = async (data) => {
  try {
    const response = await axios.post(`${API_ROOT_URL}/getallmodulebyuser`, data,httpOptions);
    return response.data;
  } catch (error) {
    console.error('Error posting data:', error);
    throw error;
  }
};



export const fetchModuleData = async (data) => {
  try {
    const response = await axios.post(`${API_ROOT_URL}/getallmodules`, data, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error posting data:', error);
    throw error;
  }
};






// Function to fetch client data from the API
export const insetClientData = async (data) => {
  try {
    const response = await axios.post(`${API_ROOT_URL}/insertclient`, data,httpOptions);
    return response.data;
  } catch (error) {
    console.error('Error posting data:', error);
    throw error;
  }
};



export const insertModuleData = async (insertData) => {
  try {
    const response = await axios.post(`${API_ROOT_URL}/insertmodule`, insertData, {
      headers :{
        'Content-Type' :'application/json'
      }
    });
    return response.data;
  } catch (error){
    console.error(`Error posting data`, error);
    throw error;
  }
}



// Function to fetch all client data
export const fetchAllClientsData = async (data) => {
  try {
    const response = await axios.post(`${API_ROOT_URL}/getallclients`, data);
    return response.data;
  } catch (error) {
    console.error('Error fetching clients data:', error);
    throw error;
  }
};

// Function to update client data from the API
export const updateClientsData = async (clientData) => {
  try {
    const response = await axios.put(`${API_ROOT_URL}/updateclient`, clientData, httpOptions);
    return response.data;
  } catch (error) {
    console.error('Error updating clients data:', error);
    throw error;
  }
};

// Function to delete client data
export const deleteClientsData = async (clientId) => {
  try {
    const response = await axios.delete(`${API_ROOT_URL}/deleteclient`, {
      data: { id: clientId }, 
      ...httpOptions,
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting clients data:', error);
    throw error;
  }
};

export const deleteModule = async (id) => {
  try {
    const response = await axios.delete(`${API_ROOT_URL}/deletemodule`, {
      data: { id: id }, 
      ...httpOptions,
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting clients data:', error);
    throw error;
  }
};


export const deleteUserData = async (id) => {
  try {
    const response = await axios.delete(`${API_ROOT_URL}/deleteuser`, {
      data: { id: id }, 
      ...httpOptions,
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting clients data:', error);
    throw error;
  }
};




// Function to fetch all org data
export const fetchAllOrgData = async (data) => {
  try {
    const response = await axios.post(`${API_ROOT_URL}/getorganization`, data, httpOptions);
    return response.data;
  } catch (error) {
    console.error('Error fetching clients data:', error);
    throw error;
  }
};


export const fetchClientNameData = async (data) => {
  try {
    const response = await axios.post(`${API_ROOT_URL}/getclientnames`, data, httpOptions);
    return response.data;
  } catch (error) {
    console.error('Error fetching clients data:', error);
    throw error;
  }
};


export const fetchOrgClientWiseData = async (data) => {
  try {
    const response = await axios.post(`${API_ROOT_URL}/getorganisationclientwise`, data, httpOptions);
    return response.data;
  } catch (error) {
    console.error('Error fetching clients data:', error);
    throw error;
  }
};


export const insertOrganizationData = async (data) => {
  try{
    const response = await axios.post(`${API_ROOT_URL}/addorganization`, data, httpOptions);
    return response.data;
  } catch(error){
    console.error('Error fetching clients data:', error);
    throw error;
  }
}


export const updateOrganizationData = async (data) => {
  try{
    const response = await axios.put(`${API_ROOT_URL}/updateorganization`, data, httpOptions);
    return response.data;
  } catch(error){
    console.error('Error fetching Organization data:', error);
  }
}

export const fetchGetAllUser = async (data) =>{
  try{ 
   const response = await axios.post(`${API_ROOT_URL}/getalluser`, data , httpOptions);
   return response.data;
  } catch(error) {
    console.error('Error fetching User data:', error);
    throw error;
  }
}


export const addUserData = async (data) => {
  try{
    const response = await axios.post(`${API_ROOT_URL}/adduser`, data, httpOptions);
  } catch(error){
    console.error('Error fetching clients data:', error);
    throw error;
  }
}


export const updateUserData = async (data) => {
  try{
    const response = await axios.put(`${API_ROOT_URL}/updateuser`, data, httpOptions);
    return response.data;
  } catch(error){
    console.error('Error updating the user data:', error);
  }
}


export const fetchAllRoleData = async (data) =>{
  try{ 
   const response = await axios.post(`${API_ROOT_URL}/getallrole`, data , httpOptions);
   return response.data;
  } catch(error) {
    console.error('Error fetching User data:', error);
    throw error;
  }
}

export const addRoleData = async (data) => {
  try{
    const response = await axios.post(`${API_ROOT_URL}/addrole`, data, httpOptions);
    return response.data;
  } catch(error){
    console.error('Error addding Role data:', error);
    throw error;
  }
}


export const fetchallmapuserrole = async (data) => {
  try{
    const response = await axios.post(`${API_ROOT_URL}/getallmapuserrole`, data, httpOptions);
    return response.data;
  } catch(error){
    console.error('Error addding Role data:', error);
    throw error;
  }
}

export const fetchroleorgwise = async (data) => {
  try{
    const response = await axios.post(`${API_ROOT_URL}/getroleorgwise`, data, httpOptions);
    return response.data;
  } catch(error){
    console.error('Error addding Role data:', error);
    throw error;
  }
}


export const fetchUserByOrgWise = async (data) => {
  try{
    const response = await axios.post(`${API_ROOT_URL}/searchuserorgwise`, data, httpOptions);
    return response.data;
  } catch(error){
    console.error('Error addding Role data:', error);
    throw error;
  }
}


export const insertmapuserrole = async (data) => {
  try{
    const response = await axios.post(`${API_ROOT_URL}/insertmapuserrole`, data, httpOptions);
    return response.data;
  } catch(error){
    console.error('Error addding Role data:', error);
    throw error;
  }
}



export const fetchallmapmodulerole = async (data) => {
  try{
    const response = await axios.post(`${API_ROOT_URL}/getallmapmodulerole`, data, httpOptions);
    return response.data;
  } catch(error){
    console.error('Error addding Role data:', error);
    throw error;
  }
}


export const fetchmoduleorgwise = async (data) => {
  try{
    const response = await axios.post(`${API_ROOT_URL}/getmoduleorgwise`, data, httpOptions);
    return response.data;
  } catch(error){
    console.error('Error addding Role data:', error);
    throw error;
  }
}


export const insertmapmodulerole = async (data) => {
  try{
    const response = await axios.post(`${API_ROOT_URL}/insertmapmodulerole`, data, httpOptions);
    return response.data;
  } catch(error){
    console.error('Error addding Role data:', error);
    throw error;
  }
}



export const updateModuleData = async (data) => {
  try{
    const response = await axios.put(`${API_ROOT_URL}/updatemodule`, data, httpOptions);
    return response.data;
  } catch(error){
    console.error('Error updating the data:', error);
    throw error;
  }
}



// Function to fetch client data from the API
export const bulkuseruploadData = async (data) => {
  try {
    const response = await axios.post(
      `${API_ROOT_URL}/bulkuserupload`,
      data, // data is FormData
      {
        headers: {
          // Remove 'Content-Type' — Axios sets it correctly for FormData
          'Authorization': `${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error posting data:', error);
    throw error;
  }
};


export const overAllUsersSearch = async (data) =>{
  try{ 
   const response = await axios.post(`${API_ROOT_URL}/overAllUsersSearch`, data , httpOptions);
   return response.data;
  } catch(error) {
    console.error('Error fetching User data:', error);
    throw error;
  }
}


export const handleForgotpassword = async (data) => {
  try {
    const response = await axios.post(`${API_ROOT_URL}/forgotpassword`, data, httpOptionsForgotpassword);
    return response.data
  } catch(error){
    console.error('Error addding Role data:', error);
    throw error;
  }
}

export const handleVerifyOTP = async (data) => {
  try {
    const response = await axios.post(`${API_ROOT_URL}/verifyotp`, data, httpOptionsForgotpassword);
    return response.data
  }catch (error){
    console.error('Error addding Role data:', error);
    throw error;
  }
}


export const handleResendOTP = async (data) => {
  try {
    const response = await axios.post(`${API_ROOT_URL}/resendotp`, data, httpOptionsForgotpassword);
    return response.data
  }catch (error){
    console.error('Error addding Role data:', error);
    throw error;
  }
}
export const handleResetPassword = async (data) => {
  try {
    const response = await axios.post(`${API_ROOT_URL}/resetpassword`, data, httpOptionsForgotpassword);
    return response.data
  }catch (error){
    console.error('Error addding Role data:', error);
    throw error;
  }
}

